import {
  Sun,
  ShieldCheck,
  AlarmSmoke,
  Film,
  KeyRound,
} from "lucide-react";
import { LIVING_CATEGORIES } from "../../data/content";

const ICONS = { Sun, ShieldCheck, AlarmSmoke, Film, KeyRound };

export default function IntelligentLiving() {
  return (
    <section
      data-testid="intelligent-living"
      className="relative bg-[var(--gx-bg)] py-24 lg:py-40 border-t border-line/60"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-end mb-16 lg:mb-24">
          <div>
            <p className="eyebrow mb-5">Intelligent Living</p>
            <h2 className="h1-display text-white max-w-[14ch]">
              Five disciplines.<br />
              <span className="text-gold">One quiet intelligence.</span>
            </h2>
          </div>
          <p className="lead max-w-[58ch]">
            Comfort. Security. Safety. Entertainment. Access. Each one elegantly engineered,
            seamlessly orchestrated — so your home anticipates rather than reacts.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line/60 border border-line/60 rounded-3xl overflow-hidden">
          {LIVING_CATEGORIES.map((c, i) => {
            const Icon = ICONS[c.icon] || Sun;
            return (
              <article
                key={c.key}
                data-testid={`living-${c.key}`}
                className="group relative bg-[var(--gx-surface)] hover:bg-[var(--gx-elev)] transition-colors duration-500 p-8 lg:p-10 min-h-[280px] flex flex-col justify-between"
              >
                <div>
                  <span className="w-12 h-12 rounded-full bg-[var(--gx-elev)] border border-line group-hover:border-gold transition-colors flex items-center justify-center">
                    <Icon className="w-5 h-5 text-gold" />
                  </span>
                  <h3 className="font-display text-2xl lg:text-3xl mt-7 tracking-tight text-white">
                    {c.title}
                  </h3>
                  <p className="text-[13px] tracking-[0.18em] uppercase text-mute mt-2">
                    {c.sub}
                  </p>
                </div>
                <p className="text-[14px] text-dim leading-relaxed mt-10 max-w-[38ch]">
                  {c.body}
                </p>
                <span className="absolute top-7 right-7 text-[11px] tracking-[0.28em] text-mute">
                  0{i + 1}
                </span>
              </article>
            );
          })}

          {/* Fifth-cell aesthetic block to balance grid */}
          <article className="hidden lg:flex bg-[var(--gx-black)] p-10 flex-col justify-between min-h-[280px]">
            <div>
              <p className="eyebrow mb-3">Curated For You</p>
              <h3 className="font-display text-2xl text-white max-w-[14ch] tracking-tight">
                An experience designed to your lifestyle.
              </h3>
            </div>
            <p className="text-[13px] text-dim max-w-[34ch]">
              Every GenieX home is hand-tuned by a senior advisor — never templated.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
